import Button from '../shared/Button.jsx';
import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import { useTeachers } from '../content/useContent.js';

export default function Teachers() {
  const teachers = useTeachers();

  return (
    <section id="teachers" className="bg-cream pb-[30px] pt-24">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <Reveal className="flex flex-wrap items-end gap-[30px]">
          <div className="min-w-[300px] flex-1">
            <p className="font-hand text-2xl text-coral">The people walking with them</p>
            <h2 className="mt-1.5 font-display text-[clamp(30px,3.6vw,50px)] font-extrabold leading-[1.03] text-forest">
              Teachers who stay long enough to matter
            </h2>
          </div>
          <Button href="#teachers" variant="outlineFlat" size="md">
            Meet all 31 →
          </Button>
        </Reveal>

        <div className="mt-[38px] grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {teachers.map((teacher, i) => (
            <Reveal
              key={teacher.name}
              index={i}
              className="rounded-[26px] border-[3px] border-forest bg-white p-[18px] shadow-[0_9px_0_rgb(20_83_45_/_0.12)]"
            >
              <div className="aspect-square overflow-hidden rounded-[20px] bg-mint">
                <ImageSlot
                  src={teacher.photo}
                  name={teacher.name}
                  alt={`${teacher.name}, ${teacher.role}`}
                />
              </div>
              <h3 className="mt-3.5 font-display text-[21px] font-extrabold text-forest">
                {teacher.name}
              </h3>
              <p className="text-sm font-bold text-coral">{teacher.role}</p>
              <p className="mt-2 text-[14.5px] leading-[1.5] text-ink-soft">
                {teacher.quote}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
